import * as React from 'react';
import * as moment from 'moment';

import { IEvent } from '../../custom/classes/event';
import { ICalendarState, IMonth, CalendarViewMode, CalendarDeviceMode } from '../../classes/calendar';
import { connect } from 'react-redux';

import GridMonthContainerView from 'grid-month-container.view';
import { ICalendarAppState } from '../../redux-state';

interface IGridMonthContainerExternalProps {

}

interface StateToProps {
    //currentMoment: moment.Moment;
    //calendarViewMode: CalendarViewMode;
    //calendarDeviceMode: CalendarDeviceMode;
}

export type GridMonthContainerProps = IGridMonthContainerExternalProps & StateToProps;

export class GridMonthContainerBase extends React.Component<GridMonthContainerProps, any> {
    render() {
        return (
            <GridMonthContainerView {...this.props} />
        )
    }
}

//function mapStateToProps(state: ICalendarAppState, ownProps: IGridMonthContainerExternalProps): StateToProps {
//    return {
//        currentMoment: state.calendar.currentDate,
//        calendarViewMode: state.calendarSettings.calendarViewMode,
//        calendarDeviceMode: state.calendarSettings.calendarDeviceMode
//    }
//}

//export default connect<StateToProps>(mapStateToProps)(GridMonthContainerBase);

export default GridMonthContainerBase;